import { render, staticRenderFns } from "./App.vue?vue&type=template&id=e48b4e60&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=e48b4e60&prod&lang=scss&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&id=e48b4e60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48b4e60",
  null
  
)

export default component.exports